import React, { useContext, useState, useEffect } from 'react';
import 'firebase/auth';
import LogoAgsafe from '../../../assets/agsafebk.png';
import { DataAtual, FormataTelefone } from '../../../functions/helper';
import Button from '../../../components/button/index.tsx';
import {
  NOTIFICAO_APLICADOR_PRODUTOR, NOTIFICAO_PADRAO, PERMITIDOS_APLICADOR, PERMITIDOS_SERICICULTOR,
} from '../../../constantes';
import UsuarioContext from '../../../context/usuario.context';
import CidadesContext from '../../../context/cidades.context';
import FirebaseContext from '../../../context/firebase.context';
import { TermosDeUso, PoliticaDEProvacidade } from '../../../components/modals';
import './cadastro-mobile.scss';
import { notify } from '../../../functions/notifications';
import { fetchCitiesByUf, fetchLocations2 } from '../../../services/apis';
import { NotificacaoBoasVindas, NotificarAplicacaoProdutorAplicador } from '../../../services/apiWhats';

function ConfirmaCadastro() {
  const {
    setUsuario, usuario,
    acepted,
    constantes,
  } = useContext(UsuarioContext);
  const {
    listCity, listUf, findLocation, findLocationSiglaUf,
  } = useContext(CidadesContext);
  const {
    VerificaLogin, Logout, UpdateUser,
  } = useContext(FirebaseContext);
  const { cadInitial } = constantes;
  const [confirmacao, setConfirmacao] = useState();
  const [mensagemInicial, setMensagemInicial] = useState([{}]);
  const [enabledButton, setEnabledButton] = useState(true);
  const [localizacao, setLocalizacao] = useState({ cidade: null, estado: null });
  const { email, activation_code: activationCode } = usuario;
  const { terms, privacity } = acepted;
  VerificaLogin('confirmacao');

  useEffect(() => { // Verifica se os termos de uso e privacidade estão aceitos
    if (terms && privacity) {
      setEnabledButton(false);
    } else {
      setEnabledButton(true);
    }
  }, [terms, privacity]);

  useEffect(() => { // Busca todos as cidades com base no estado
    findLocationSiglaUf(localizacao.estado);
  }, [localizacao.estado]);

  useEffect(() => { // Verifica o state Aguardando Ativação
    if (usuario.state && usuario.state !== 'Aguardando Ativação') {
      UpdateUser({ update: null, setDesabilitado: null });
    }
  }, [usuario.state]);

  useEffect(() => { // Verifica o state Aguardando Ativação
    findLocation(usuario.estado, usuario.cidade);
  }, [usuario.cidade]);

  const mesgSendCode = {
    a: {
      body: `Oi,  ${usuario.nome}! Que bom ter você aqui 😃

      Olha que legal, agora, assim que uma aplicação de agroquímicos  for realizada próxima a sua localização você vai receber notificações em tempo real por aqui.

      Ah! O código de confirmação da sua conta  AGSAFE é ${usuario.activation_code}.`,
      data: DataAtual(),
      read: false,
      title: 'Código de confirmação',
      uid: 'a',
    },
  };

  function atualizaLocalizacao(sigla) {
    fetchCitiesByUf(sigla).then((cidades) => {
      cidades.sort((a, b) => a.nome.localeCompare(b.nome));
      const { nome: cidade } = cidades[0];
      fetchLocations2(cidade, sigla).then(({
        latitude, longitude, estado,
      }) => {
        setUsuario((prevState) => ({
          ...prevState, cidade, estado, latitude, longitude,
        }));
        setLocalizacao({ cidade, estado });
      });
    }).catch(() => {});
  }

  useEffect(() => { // Busca todos as cidades com base no estado
    findLocationSiglaUf(localizacao.estado);
    atualizaLocalizacao(localizacao.estado);
  }, [localizacao.estado]);

  useEffect(() => { // Verifica o state Aguardando Ativação
    if (listUf[0]) {
      const { sigla } = listUf[0];
      atualizaLocalizacao(sigla);
    }
  }, [listUf]);

  function verificaCode() { // Verifica se o código de confirmação digitado é válido
    if (parseInt(confirmacao, 10) === activationCode) {
      NotificacaoBoasVindas({ telefone: usuario.celular, nome: usuario.nome });
      return setUsuario((prevState) => ({
        ...prevState, state: 'Conta Ativada', cidade: localizacao.cidade, estado: localizacao.estado,
      }));
    }
    return notify('error', 'Código inválido.');
  }

  function verificaInput() { // Verifica inputs obrigatórios
    let retorno = true;
    const inputs = [
      'confirmacao',
      'estado',
      'cidade',
      'fone',
      'endereco',
      'bairro',
      'complemento',
      'cpfCnpj',
      'inscricao',
      'site',
      'empresa',
    ];
    const obj = [];

    inputs.forEach((valor) => {
      const { value, required } = document.querySelector(`#${valor}`);
      if (valor === 'estado' || valor === 'cidade') {
        const newValue = valor === 'estado'
          ? localizacao.estado
          : localizacao.cidade;
        obj.push({
          [valor]: {
            value: newValue,
            required,
          },
        });
      } else {
        obj.push({
          [valor]: {
            value,
            required,
          },
        });
      }
    });
    obj.forEach((item, index) => {
      const { value, required } = item[`${inputs[index]}`];
      if (retorno && (!item[`${inputs[index]}`].value && item[`${inputs[index]}`].required)) {
        retorno = false;
      }

      const inputReq = document.querySelector(`#label-${inputs[index]}`);
      if (!value && required) {
        if (inputs[index] === 'estado' || inputs[index] === 'cidade') {
          inputReq.classList.add(`${inputs[index]}-obrigatorio`);
        } else {
          inputReq.classList.add('obrigatorio');
        }
      } else {
        try {
          if (inputs[index] === 'estado' || inputs[index] === 'cidade') {
            inputReq.classList.remove(`${inputs[index]}-obrigatorio`);
          } else {
            inputReq.classList.remove('obrigatorio');
          }
        } catch (error) {
          if (!error.message) return null;
        }
      }
      return null;
    });
    if (retorno) {
      verificaCode();
    }
  }

  function handleChange({ target }) {
    const tipoDeCadastro = document.querySelector('#tipoDeCadastro').value;
    if (tipoDeCadastro === 'Aplicador de Defensivos / Produtor') {
      setMensagemInicial([mesgSendCode, NOTIFICAO_APLICADOR_PRODUTOR]);
      NotificarAplicacaoProdutorAplicador({ celular: usuario.celular, nome: usuario.nome });
    } else {
      setMensagemInicial([mesgSendCode, NOTIFICAO_PADRAO]);
    }
    if (tipoDeCadastro === 'Aplicador de Defensivos') {
      const { name, value } = target;
      const change = name === 'fone' ? FormataTelefone(value) : value.replace(' / Produtor', '');
      setUsuario((prevState) => ({
        ...prevState,
        [name]: change,
        premissoes: PERMITIDOS_APLICADOR,
        tipoDeCadastro,
        notifications: mensagemInicial,
      }));
    } else if (tipoDeCadastro === 'Bicho-da-seda (Sericicultura)') {
      const { name, value } = target;
      const change = name === 'fone' ? FormataTelefone(value) : value.replace(' / Produtor', '');
      setUsuario((prevState) => ({
        ...prevState,
        [name]: change,
        premissoes: PERMITIDOS_SERICICULTOR,
        tipoDeCadastro,
        notifications: mensagemInicial,
      }));
    } else {
      const { name, value } = target;
      const change = name === 'fone' ? FormataTelefone(value) : value.replace(' / Produtor', '');
      setUsuario((prevState) => ({
        ...prevState, [name]: change, tipoDeCadastro, notifications: mensagemInicial,
      }));
    }
  }

  return (
    <div id="cadastrar-novo-usuario">
      <TermosDeUso aceite={{ show: true }} />
      <PoliticaDEProvacidade aceite={{ show: true }} />
      <main>
        <div className="texto-header-confirm">
          <div className="header-novo-usuario-concluir">
            <div className="texto-header-concluir">
              <span className="criar-conta">
                Criar uma conta gratuíta.
              </span>
              <span className="cadastre-se">
                Conclua seu cadastro para continuar
              </span>
            </div>
            <div className="logotipo-cadastro-concluir">
              <img src={LogoAgsafe} alt="Logo" />
            </div>
          </div>
        </div>

        <form method="post" action="" className="formulario-cadastro">
          <label id="label-confirmacao" className="confirmacao">
            <span>
              Cod. de Confirmação
            </span>
            <input
              onChange={(e) => setConfirmacao(e.target.value)}
              type="text"
              required
              id="confirmacao"
              name="confirmacao"
              placeholder="Código Recebido"
              value={confirmacao}
            />
          </label>
          <label id="label-estado" className="estado">
            <span>
              Informe Estado
            </span>
            <select
              className="form-control"
              id="estado"
              name="estado"
              required
              onChange={(e) => {
                for (let index = 0; index < listUf.length; index += 1) {
                  const element = listUf[index];
                  if (listUf[index].id === parseInt(e.target.value, 10)) {
                    setLocalizacao((prevState) => ({ ...prevState, estado: element.sigla }));
                  }
                }
                handleChange(e);
              }}
            >
              {listUf.map((a) => (
                <option value={a.id}>{a.nome}</option>
              ))}
            </select>
          </label>
          <label id="label-cidade" className="cidade">
            <span>
              Informe a cidade
            </span>
            <select
              className="form-control"
              name="cidade"
              id="cidade"
              required
              onChange={(e) => {
                setLocalizacao((prevState) => ({ ...prevState, cidade: e.target.value }));
                setUsuario((prevState) => ({ ...prevState, cidade: e.target.value }));
              }}
            >
              {listCity.map((a) => (
                <option value={a.sigla}>{a.nome}</option>
              ))}
            </select>
          </label>
          <label id="label-fone" className="fone">
            <span>
              Telefone
            </span>
            <input
              onChange={handleChange}
              type="text"
              name="fone"
              id="fone"
              required
              placeholder="(00)0000-0000"
              value={usuario.fone}
            />
          </label>
          <label id="label-endereco" className="endereco">
            <span>
              Endereço
            </span>
            <input
              onChange={handleChange}
              type="text"
              required
              name="endereco"
              id="endereco"
              placeholder="ex. Rua 1º de Maio"
              value={usuario.endereco}
            />
          </label>
          <label id="label-bairro" className="bairro">
            <span>
              Bairro
            </span>
            <input
              onChange={handleChange}
              type="text"
              required
              name="bairro"
              id="bairro"
              placeholder="ex. Centro"
              value={usuario.bairro}
            />
          </label>
          <label id="label-complemento" className="complemento">
            <span>
              Complemento
            </span>
            <input
              onChange={handleChange}
              type="text"
              name="complemento"
              id="complemento"
              placeholder="ex. Apto 15"
              value={usuario.complemento}
            />
          </label>
          <label id="label-cpfCnpj" className="cpfCnpj">
            <span>
              Cpf ou CNPJ
            </span>
            <input
              onChange={handleChange}
              type="text"
              required
              name="cpfCnpj"
              id="cpfCnpj"
              placeholder="Informe o Nº"
              value={usuario.cpfCnpj}
            />
          </label>
          <label id="label-inscricao" className="inscricao">
            <span>
              Inscrição Municipal
            </span>
            <input
              onChange={handleChange}
              type="text"
              name="inscricao"
              id="inscricao"
              placeholder="Informe o Nº"
              value={usuario.inscricao}
            />
          </label>
          <label id="label-website" className="site">
            <span>
              Website
            </span>
            <input
              onChange={handleChange}
              type="text"
              name="site"
              id="site"
              placeholder="www.meusite.com.br"
              value={usuario.site}
            />
          </label>
          <label id="label-tipoDeCadastro" className="tipoDeCadastro">
            <span>
              Tipo de Cadastro
            </span>
            <select
              className="form-control"
              name="tipoDeCadastro"
              id="tipoDeCadastro"
              value={usuario.tipoDeCadastro}
              onChange={handleChange}
            >
              {cadInitial.map((tipo) => (
                <option value={tipo.valor}>{tipo.valor}</option>
              ))}
            </select>
          </label>
          <label id="label-empresa" className="empresa">
            <span>
              Informação Adicional
            </span>
            <input
              onChange={handleChange}
              type="text"
              name="empresa"
              id="empresa"
              placeholder="Nome da Empresa, Organização Pública ou Associação vinculado (Opcional)"
              value={usuario.empresa}
            />
          </label>
          {usuario.email && (
            <div className="texto-nao-e">
              <button
                onClick={() => Logout()}
                type="button"
                className="criar-conta buttons-transparent"
              >
                <span>
                  {`Não é ${email}?`}
                </span>
              </button>
            </div>
          )}

          <div className="buttons-novo-usuario">
            <Button
              disabled={enabledButton}
              type="submit"
              onClick={() => (verificaInput())}
            >
              CONFIRMAR CONTA
            </Button>

            <div className="desktop-termos">
              <button className="buttons-transparent" type="button" data-toggle="modal" data-target="#modal-termos-de-uso">
                {terms
                  ? (
                    <>
                      <span>
                        Você Aceitou os Termos de Uso.
                      </span>
                      <i className="fas fa-check-double acepted" />
                    </>
                  )
                  : (
                    <>
                      <span>
                        Ao se cadastrar você concorda com os Termos de Uso.
                      </span>
                      <i className="far fa-times-circle not-acepted" />
                    </>
                  )}
              </button>
              <button className="buttons-transparent" type="button" data-toggle="modal" data-target="#modal-politica-de-privacidade">
                {privacity
                  ? (
                    <>
                      <span>
                        Você Aceitou as Políticas de Privacidade.
                      </span>
                      <i className="fas fa-check-double acepted" />
                    </>
                  )
                  : (
                    <>
                      <span>
                        Ao se cadastrar você concorda com as Políticas de Privacidade.
                      </span>
                      <i className="far fa-times-circle not-acepted" />
                    </>
                  )}
              </button>
            </div>
            <div className="mobile-termos">
              <button className="buttons-transparent" type="button" data-toggle="modal" data-target="#modal-termos-de-uso">
                {terms
                  ? (
                    <>
                      <span>
                        Você Aceitou os Termos de Uso.
                      </span>
                      <i className="fas fa-check-double acepted" />
                    </>
                  )
                  : (
                    <>
                      <span>
                        Visualizar os Termos de Uso.
                      </span>
                      <i className="far fa-times-circle not-acepted" />
                    </>
                  )}
              </button>
              <button className="buttons-transparent" type="button" data-toggle="modal" data-target="#modal-politica-de-privacidade">
                {privacity
                  ? (
                    <>
                      <span>
                        Você Aceitou as Políticas de Privacidade.
                      </span>
                      <i className="fas fa-check-double acepted" />
                    </>
                  )
                  : (
                    <>
                      <span>
                        Visualizar as Políticas de Privacidade.
                      </span>
                      <i className="far fa-times-circle not-acepted" />
                    </>
                  )}
              </button>
            </div>
          </div>
        </form>
      </main>
    </div>
  );
}

export default ConfirmaCadastro;
